import { Routes } from '@angular/router';
import { pageRoutes } from './pages/pages.routes';
import { APP_ROUTES } from './shared/constants';

export const routes: Routes = [
  {
    path: APP_ROUTES.onepayResult,
    loadComponent: () =>
      import('./pages/payment-result/onepay-result.component').then(
        (m) => m.OnepayResultComponent,
      ),
  },
  {
    path: '',
    children: pageRoutes,
  },
  {
    path: 'error',
    children: [
      {
        path: '404',
        loadComponent: () =>
          import('./pages/errors/e404/e404.component').then(
            (m) => m.E404Component,
          ),
      },
      {
        path: '500',
        loadComponent: () =>
          import('./pages/errors/e500/e500.component').then(
            (m) => m.E500Component,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'error/404' },
];
